import React from 'react';

const Badge = ({message}:{message?:string}) => (
  <div className="px-2 py-0 text-bg-xs rounded-xl bg-white/40 text-gray-600 group-hover:text-white">
		{message ? message : 'Coming Soon'}
	</div>
);

export default Badge;
